<script setup lang="ts">
import { cn } from '@/lib/utils'
import {
    ScrollAreaCorner,
    ScrollAreaRoot,
    type ScrollAreaRootProps,
    ScrollAreaViewport,
} from 'reka-ui'
import ScrollBar from './ScrollBar.vue'

const props = withDefaults(defineProps<ScrollAreaRootProps & { class?: string }>(), {
    class: '',
    orientation: 'vertical',
})
</script>

<template>
    <ScrollAreaRoot :type="type" :class="cn('relative overflow-hidden', props.class)">
        <ScrollAreaViewport as="template" class="h-full w-full rounded-[inherit]">
            <slot />
        </ScrollAreaViewport>
        <ScrollBar />
        <ScrollAreaCorner />
    </ScrollAreaRoot>
</template>
